module.exports = {
	"articleTitle1": "The story of Mighty Good, Ann Arbor's coffee mainstay ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Mighty Good Coffee",
	"articleLink1": "https://www.michigandaily.com/section/arts/mighty-good-lead",
	"articleLink2": "https://www.michigandaily.com/news/brillig-dry-bar-looks-foster-recreation-without-alcohol",
	"articleSnippet1": "Feb 17, 2016 ... Along with fostering national and international relationships within the coffee \ncommunity, the café maintains a focus on local involvement.",
	"articleSnippet2": "Jan 25, 2015 ... Madeline Bath/Daily During the Brillig Dry Bar pop up Saturday at Mighty Good \nCoffee. Buy this photo.",
	"foodRecommendations": [],
	"articleTitle2": "Brillig Dry Bar serves up jazz, non-alcoholic beverages ",
	"address": "217 N Main St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160217/msh.ART_.mightygoodcoffee.2.17.16.002.jpg?itok=lUVu5ADZ",
			"author": "Mazie Hyams",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.283,
		"lng": -83.7486
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mightygoodcoffee.json
// module id = 923
// module chunks = 0